import * as pdfjsLib from "pdfjs-dist/build/pdf";

// Worker desde CDN matcheando la versión instalada (mismo patrón que parseSwiftPdf / parseOnSignPdf
// / el visor). Centralizado acá para que TODOS los parsers por proveedor compartan una única
// extracción de texto — así el setup del worker y el join de items viven en un solo lugar.
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.js`;

/**
 * Extracción de texto de un PDF con pdfjs, 100% en cliente (no sube el archivo).
 * Une los `items` de cada página con un espacio y separa páginas con `\n` — idéntico al patrón
 * histórico de parseOnSignPdf / parseSwiftPdf. Cada parser por proveedor corre sus regex sobre
 * el string resultante.
 *
 * @param {File} file
 * @returns {Promise<string>}
 */
export const extraerTextoPdf = async (file) => {
  const buffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: buffer }).promise;
  let texto = "";
  for (let i = 1; i <= pdf.numPages; i++) {
    // eslint-disable-next-line no-await-in-loop
    const page = await pdf.getPage(i);
    // eslint-disable-next-line no-await-in-loop
    const content = await page.getTextContent();
    texto += `${content.items.map((it) => it.str).join(" ")}\n`;
  }
  return texto;
};
